import React, { createElement, forwardRef } from 'react';
import { TreeSelect } from '@alifd/next';
import request from '@/utils/request';
import { parseParams, transformSchema2tree } from './index';
const EntityTree = ({ onChange, paramsMap, $event, field, ...restProps }, ref) => {
    const [dataSource, setDataSource] = React.useState([]);
    $event.useSubscription(() => {
        queryList();
    });
    const queryList = async () => {
        const params = parseParams(paramsMap, field);
        if (!params?.entityCd) {
            return;
        }
        const { content } = await request(`/api/exchange/entity/extend/${params?.entityCd}`);
        const schema = content?.bigData?.dataContent || '{}';
        const data = transformSchema2tree(JSON.parse(schema));
        setDataSource(data);
    };
    return (createElement(TreeSelect, { ...restProps, showSearch: true, hasClear: true, ref: ref, dataSource: dataSource, onChange: onChange }));
};
export const EntityTreeRef = forwardRef(EntityTree);
export default EntityTreeRef;
